import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { TransactionsDownloadInput, TransactionsDownloadPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TransactionsDownloadInput;
type TData = TransactionsDownloadPayload;

export const useTransactionsDownload = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation transactionsDownload($input: TransactionsDownloadInput!) {
      transactionsDownload(input: $input) {
        success
        errors
        errorCode
        csvData
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
